/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { ExpanderColumn, EXPANDER_CELL_ID } from '../columns';
export const useExpanderCell = (subComponent, expanderCell, isRowDisabled) => (hooks) => {
    if (!subComponent) {
        return;
    }
    hooks.allColumns.push((columns) => {
        const hasExpanderColumn = columns.find((c) => c.id === EXPANDER_CELL_ID);
        if (hasExpanderColumn) {
            return columns;
        }
        const expanderColumn = ExpanderColumn({
            subComponent,
            isDisabled: isRowDisabled,
        });
        return [
            {
                ...expanderColumn,
                Cell: expanderCell
                    ? (cellProps) => React.createElement(React.Fragment, null, expanderCell(cellProps))
                    : expanderColumn.Cell,
            },
            ...columns,
        ];
    });
};
